module.exports = __webpack_public_path__ + "img/versatile.25641eb0.svg";